
import centerIcon from 'images/calendar/center.svg';
import classroomIcon from 'images/calendar/classroom.svg';
import studentIcon from 'images/calendar/student.svg';
import { EVENT_TYPES, TAGS } from './constants';

export default [
  {
    id: EVENT_TYPES.CENTER,
    isRoot: true,
    title: 'calendar_events:CENTERS',
    description: 'calendar_events:ALL_PARENTS_CENTERS_INVITED',
    color: '#D1296D',
    icon: centerIcon,
    active: Math.random() >= 0.3,
    availableFor: (user: any) => user.is_owner || user.tags
      .map((tag: any) => tag.name)
      .some((tag: any) => ![TAGS.TEACHER].includes(tag)),
    iconTheme: `
      height: 56px;
      position: relative;
      right: 6px;
      align-self: center;
    `
  },
  {
    id: EVENT_TYPES.CLASSROOM,
    isRoot: false,
    title: 'calendar_events:CLASSROOMS',
    description: 'calendar_events:ALL_PARENTS_CLASSROOMS_INVITED',
    color: '#913FA3',
    icon: classroomIcon,
    active: Math.random() >= 0.3,
    availableFor: (user: any) => {
      return user.is_owner ||
        user.tags
          .map((tag: any) => tag.name)
          .some((tag: any) => [TAGS.TEACHER, TAGS.ADMIN, TAGS.DIRECTOR].includes(tag));
    },
    iconTheme: `
      height: 90px;
      position: relative;
      right: 6px;
    `
  },
  {
    id: EVENT_TYPES.STUDENT,
    isRoot: false,
    title: 'calendar_events:STUDENTS',
    description: 'calendar_events:ALL_PARENTS_STUDENTS_INVITED',
    color: '#3EB646',
    icon: studentIcon,
    active: Math.random() >= 0.3,
    availableFor: (user: any) => {
      return user.is_owner ||
        user.tags
          .map((tag: any) => tag.name)
          .some((tag: any) => [TAGS.TEACHER, TAGS.ADMIN, TAGS.DIRECTOR].includes(tag));
    },
    iconTheme: `
      align-self: center;
      height: 72px;
      right: 6px;
      position: relative;
    `
  },
];
